import React, { useEffect, useState } from 'react';
import { getURLSearchParamByKey } from 'src/utils';
import {
  getMaintenanceConfig,
  setMaintenanceSnapshot,
} from 'src/utils/maintenance';
import { resolveLocale } from 'src/utils/maintenanceContract';

import Maintenance from './index';

const POLL_INTERVAL_MS = 60 * 1000;
const MIN_FETCH_GAP_MS = 60 * 1000;

const DISABLED = Object.freeze({ enabled: false });

export default function MaintenanceGate({ children }) {
  const [config, setConfig] = useState(DISABLED);

  useEffect(() => {
    let cancelled = false;
    let lastFetchedAt = 0;
    let timer = null;

    const sync = async () => {
      lastFetchedAt = Date.now();
      restartTimer();

      try {
        const next = await getMaintenanceConfig();

        if (!cancelled) {
          setMaintenanceSnapshot(next);
          setConfig(next);
        }
      } catch (error) {
        if (!cancelled) {
          setMaintenanceSnapshot(DISABLED);
          setConfig(DISABLED);
        }
      }
    };

    const syncWhenVisible = () => {
      if (
        document.visibilityState === 'visible' &&
        Date.now() - lastFetchedAt >= MIN_FETCH_GAP_MS
      ) {
        sync();
      }
    };

    // 週期輪詢不過 gap 檢查(Date.now() 被校時往回跳不會跳過整輪);
    // gap 只用在 visibilitychange,避免頻繁切換分頁狂打
    const syncOnTick = () => {
      if (document.visibilityState === 'visible') {
        sync();
      }
    };

    function restartTimer() {
      if (timer) {
        clearInterval(timer);
      }
      timer = setInterval(syncOnTick, POLL_INTERVAL_MS);
    }

    sync();

    document.addEventListener('visibilitychange', syncWhenVisible);

    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', syncWhenVisible);
    };
  }, []);

  if (!config.enabled) {
    return children;
  }

  const locale = resolveLocale(getURLSearchParamByKey('locale'));

  return (
    <Maintenance
      copy={config.copy && config.copy[locale]}
      locale={locale}
      until={config.until}
    />
  );
}
